import React from 'react';

const CustomerLogos = () => {
  const logos = [
    {
      name: 'AZXCG',
      url: 'https://images.pexels.com/photos/2312369/pexels-photo-2312369.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
    },
    {
      name: 'Gbyard',
      url: 'https://images.pexels.com/photos/2312371/pexels-photo-2312371.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
    },
    {
      name: 'Hconda',
      url: 'https://images.pexels.com/photos/2312372/pexels-photo-2312372.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
    },
    {
      name: 'HydebioLabs',
      url: 'https://images.pexels.com/photos/2312373/pexels-photo-2312373.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
    },
    {
      name: 'Hydepharm',
      url: 'https://images.pexels.com/photos/2312374/pexels-photo-2312374.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
    },
    {
      name: 'MylandSupplement',
      url: 'https://images.pexels.com/photos/2312375/pexels-photo-2312375.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
    },
    {
      name: 'NevermindLimo',
      url: 'https://images.pexels.com/photos/2312376/pexels-photo-2312376.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
    }
  ];

  return (
    <div className="bg-white py-12 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-center text-lg font-semibold text-gray-600 mb-8">
          Trusted by industry leaders worldwide
        </p>
        <div className="relative">
          <div className="flex space-x-12 animate-scroll">
            {[...logos, ...logos].map((logo, index) => (
              <div
                key={index}
                className="flex-none w-32 h-20 flex items-center justify-center"
              >
                <img
                  src={logo.url}
                  alt={logo.name}
                  className="max-h-12 object-contain grayscale hover:grayscale-0 transition-all"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerLogos;